import { render, staticRenderFns } from "./LatestArticles.vue?vue&type=template&id=72162f96&scoped=true&"
import script from "./LatestArticles.vue?vue&type=script&lang=js&"
export * from "./LatestArticles.vue?vue&type=script&lang=js&"
import style0 from "./LatestArticles.vue?vue&type=style&index=0&id=72162f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72162f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VIcon,VRow})
